<template>
    <b id="icon-back">
        <i class="fas fa-arrow-left text-green"></i>
    </b>
</template>

<script>
    export default {
        name: 'BackButton',
    }
</script>

<style scoped>
    #icon-back {
        /* position: absolute; */
        /* top: 2rem; */
        /* left: 2rem; */
        cursor: pointer;
        color: #2096F3;
        width: 2rem;
        transition: 0.4s;
    }
    #icon-back:hover {
        opacity: 0.7;
        transition: 0.4s ease-in-out;
    }
</style>
